<mat-toolbar class="footer">
  <span class="foot1"></span>
  <span class="foot2"></span>
  <span class="foot3"></span>
  <span class="foot4"></span>
</mat-toolbar>
